import React from 'react'

const SESSION_HANDLE_CONFIG_CHANGED_EVENT = 'config-changed'

function safelyReadSessionHandleConfig(sessionHandle) {
  if (!sessionHandle?.getConfig) {
    return null
  }

  try {
    return sessionHandle.getConfig() || null
  } catch (error) {
    return null
  }
}

export function useRtcSessionHandleConfig(sessionHandle) {
  const [compatibilityConfig, setCompatibilityConfig] = React.useState(() =>
    safelyReadSessionHandleConfig(sessionHandle),
  )

  React.useEffect(() => {
    if (!sessionHandle?.getConfig) {
      setCompatibilityConfig(null)
      return undefined
    }

    setCompatibilityConfig(safelyReadSessionHandleConfig(sessionHandle))

    if (typeof sessionHandle?.on !== 'function') {
      return undefined
    }

    try {
      return sessionHandle.on(SESSION_HANDLE_CONFIG_CHANGED_EVENT, () => {
        setCompatibilityConfig(safelyReadSessionHandleConfig(sessionHandle))
      })
    } catch (error) {
      setCompatibilityConfig(null)
      return undefined
    }
  }, [sessionHandle])

  return compatibilityConfig
}

